import { SupportedOnRamps, getAsset, getNetwork, getProvider } from '@usecapsule/web-sdk';
export class OnRampConfigError extends Error {
    constructor(message) {
        super(`On-ramp configuration error: ${message}.`);
        this.name = 'OnRampConfigError';
    }
}
function checkHasProviders({ providers }) {
    if (!providers || providers.length < 1) {
        throw new OnRampConfigError('No providers are configured');
    }
}
function checkDuplicateProviders({ providers }) {
    providers.forEach(({ id: providerProp }, index) => {
        const provider = getProvider(providerProp);
        if (providers.findIndex(p => getProvider(p.id) === provider) !== index) {
            throw new OnRampConfigError(`Provider ${provider} is configured more than once`);
        }
    });
}
function checkUnsupportedCombos({ network: networkProp, asset: assetProp, providers }) {
    var _a;
    const [network, asset] = [getNetwork(networkProp), getAsset(assetProp)];
    if (!((_a = SupportedOnRamps[network]) === null || _a === void 0 ? void 0 : _a[asset])) {
        throw new Error(`Asset ${asset} does not exist on network ${network}`);
    }
    providers.forEach(({ id: providerProp }) => {
        var _a, _b;
        const provider = getProvider(providerProp);
        if (!((_b = (_a = SupportedOnRamps[network]) === null || _a === void 0 ? void 0 : _a[asset]) === null || _b === void 0 ? void 0 : _b[provider])) {
            throw new OnRampConfigError(`Provider ${provider} does not support buying ${asset} on ${network}`);
        }
    });
}
export function validateOnRampConfig(obj) {
    if (!obj) {
        return false;
    }
    checkHasProviders(obj);
    checkDuplicateProviders(obj);
    checkUnsupportedCombos(obj);
    return true;
}
